// FILE: frontend/src/components/PTTButton.jsx
// Push-to-talk button OR auto-VAD recording indicator
// Based on uiConfig.push_to_talk setting

import React from 'react'

export default function PTTButton({ uiConfig, micActive, isRecording, onTogglePTT }) {
  if (uiConfig?.push_to_talk) {
    return (
      <div className="ptt-area">
        <button
          className={`ptt-btn ${micActive ? 'active' : 'idle'}`}
          onClick={onTogglePTT}
        >
          🎤 {micActive ? 'Tap to finish speaking' : 'Tap to speak'}
        </button>
        {!micActive && (
          <div className="ptt-hint">Press and release when done</div>
        )}
      </div>
    )
  }

  // Auto-VAD mode
  if (!isRecording) return null

  return (
    <div className="ptt-area">
      <div className="recording-indicator">
        <div className="recording-dot" />
        Recording...
      </div>
    </div>
  )
}
